import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../utils/dateUtils';
import dayjs from 'dayjs';

const ExportAll = (props) => {
  const { taxData,searchType,bookingNumber,startDate,endDate,year } = props;

  // Define custom headers and their corresponding data mapping
  //  'Booking Number': row.bookingNumber,
  //                 'Customer Name': row.customerName,
  //                 'Customer Address': row.customerAddress,
  //                 'State': row.state,
  //                 'State Code': row.stateCode,
  //                 'Service Date': dayjs(row.serviceDate).format('DD-MM-YYYY'),
  //                 'Charge Type': row.chargeType,
  //                 'Service Name': row.serviceName,
  //                 'SAC Code': row.sacCode || '',
  //                 'RCM': row.rcm || '',
  //                 'Quantity': row.quantity,
  //                 'Unit Price': row.unitPrice,
  //                 'Base Amount': row.baseAmount,
  //                 'Coin Discount': row.coinDiscount,
  //                 'Coupon Discount': row.couponDiscount,
  //                 'Taxable Amount': row.taxableAmount,
  //                 'IGST': row.igst,
  //                 'CGST': row.cgst,
  //                 'SGST': row.sgst,
  //                 'Total GST': row.totalGst,
  //                 'Total Amount': row.totalAmount,
  //                 'Tax Rate': row.taxRate
  const exportMapping = [
    {
      header: 'bookingNumber',
      value: (row) => `${row.bookingNumber}`
    },
    {
      header: 'subTotal',
      value: (row) => `${row.subTotal}`
    },
    {
      header: 'discount',
      value: (row) => `${row.discount}`
    },
    {
      header: 'coinValue',
      value: (row) => `${row.coinValue}`
    },
    {
      header: 'couponAmount',
      value: (row) => `${row.couponAmount}`
    },
    {
      header: 'platformCharges',
      value: (row) => `${row.platformCharges}`
    },
    {
      header: 'convenienceFee',
      value: (row) => `${row.convenienceFee}`
    },
    {
      header: 'VisitingCharge',
      value: (row) => `${row.VisitingCharge}`
    },
    {
      header: 'tax',
      value: (row) => `${row.tax}`
    },
    {
      header: 'total',
      value: (row) => `${row.total}`
    },
    {
      header: 'serviceDate',
      value: (row) => row.serviceDate ? `="${row.serviceDate}"` : ''
    },
    {
      header: 'bookingStatus',
      value: (row) => `${row.bookingStatus}`
    },
    {
      header: 'Expert Name',
      value: (row) => `${row.expertName}`
    },
    {
      header: 'Expert Id',
      value: (row) => `${row.expertId}`
    },
    {
      header: 'Total Discount (₹)',
      value: (row) => `${row.total_discount}`
    },
    {
      header: 'Net Base (₹)',
      value: (row) => `${row.netBase}`
    },
    {
      header: 'Expert Platform Fee (Base) (₹)',
      value: (row) => `${row.ExpertPlatformBaseFee}`
    },
    {
      header: 'GST on Platform Fee (18%) (₹)',
      value: (row) => `${row.GSTonPlatformFee}`
    },
    {
      header: 'Expert Platform Fee + GST (₹)',
      value: (row) => `${row.ExpertPlatformFeeWithGST}`
    },
    {
      header: 'TIP (₹)',
      value: (row) => `${row.tip}`
    },
    {
      header: 'Adjustment (₹)',
      value: (row) => `${row.Adjustment}`
    },
    {
      header: 'TCS (₹)',
      value: (row) => `${row.TCS}`
    },
    {
      header: 'Payable Amount (₹)',
      value: (row) => `${row.payableAmount}`
    },
    {
      header: 'Status',
      value: (row) => `${row.Status}`
    },
    {
      header: 'Remarks',
      value: (row) => `${row.Remarks}`
    },
    {
      header: 'Payout Cyle Date',
      value: (row) => row.PayoutCyleDate ? `="${row.PayoutCyleDate}"` : ''
    },
    {
      header: 'Paid By Customer',
      value: (row) => `${row.PaidByCustomer}`
    },
    {
      header: 'Diff Amount-Payable vs By Cust',
      value: (row) => `${row.DiffAmountPayablevsByCust}`
    },
    {
      header: 'Cudel Earning',
      value: (row) => `${row.CudelEarning}`
    }
  ];

  const handleExportAllRows = async () => {
    try {
      // Swal.fire({
      //   title: 'Exporting Data',
      //   text: 'Please wait while we prepare your download...',
      //   icon: 'info',
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   }
      // });

      // Transform data using custom mapping
      const exportData = taxData.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob(['﻿', csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = `Expert_Payout_Record_list_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="${fileName}.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;